module.exports = __webpack_public_path__ + "img/parkour_4.b8885572.jpg";